var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-details-btn"},[_c('router-link',{staticClass:"display-1 font-weight-bold",attrs:{"to":"/Map/1"}},[_c('v-btn',[_vm._v(" Map Details")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }